export default "__VITE_ASSET__L5Vic5tn__"